import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { SideLinks } from 'components/sidelinks/sidelinks';

import { ContracteumLogo } from 'components/contracteum-logo';
import { LinkProps, linksGeneral, linksLimitedUser } from 'config/links';
import { AppRoutes } from 'config/routes';
import { useLimits } from 'hooks';
import {
  useGetMyCoreWidgetQuery,
} from 'store/api/organizations';
import styles from './Sidenav.module.scss';
import { useMeQuery } from 'store/api/profile';

export const SideNav = () => {
  const { isFetching, isLimitedUser } = useLimits();

  const { data } = useGetMyCoreWidgetQuery();

  const flatWidgetLinks: LinkProps[] = useMemo(() => {
    if (!Array.isArray(data) || data?.length === 0) return [];

    return data?.map((widget) => {
      const rawFileds = Array.isArray(widget?.fields) ? widget?.fields : [];

      const sorted = [...rawFileds].sort((a, b) => {
        const ai = Number(a?.viewIndex ?? 0) || 0;
        const bi = Number(b?.viewIndex ?? 0) || 0;
        return ai - bi;
      });

      const subLinks =
        sorted?.map((field) => ({
          label: field?.viewName ?? '',
          path:
            AppRoutes.Dashboard.Home +
            AppRoutes.Dashboard.CustomWidget.Home +
            `?name=${encodeURIComponent(field?.path ?? '')}`,
        })) ?? [];

      return {
        label: widget?.header,
        path: subLinks[0].path,
        // icon: widget?.iconHash ? <img src={widget?.iconHash} alt="" /> : <></>,
        icon: <></>,
        subLinks,
      };
    });
  }, [data]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.wrapperLogo}>
          <Link style={{ textDecoration: 'none' }} to="/" className={styles.logo}>
            <ContracteumLogo />
          </Link>
        </div>

        <div className={styles.content}>
          <div className={styles.links}>
            <SideLinks
              links={
                isLimitedUser ? linksLimitedUser : [...linksGeneral, ...(flatWidgetLinks ?? [])]
              }
            />
            {!isFetching && isLimitedUser && (
              <div className={styles.limitedUser}>
                <span>
                  {
                    'Вы не связаны ни с одной организацией. Вы можете пользоваться только разделом `Доверенности`.'
                  }
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
